import type { PixKeyType } from "@caloteiros/shared";
import { useState } from "react";
import type { ReactElement } from "react";
import { pixTypeLabel } from "../lib/format";
import { copyToClipboard } from "../lib/share";
import { useToast } from "../lib/toast";
import { IconCheck, IconCopy, IconPix } from "./Icons";

/** A chave Pix com botao de copiar — o gesto mais repetido do app. */
export function PixBox({
  pixKey,
  pixKeyType,
  ownerName,
}: {
  pixKey: string | null;
  pixKeyType: PixKeyType | null;
  ownerName: string;
}): ReactElement | null {
  const toast = useToast();
  const [copied, setCopied] = useState(false);

  if (!pixKey) return null;

  const handleCopy = async (): Promise<void> => {
    const ok = await copyToClipboard(pixKey);
    if (!ok) {
      toast.error("Não consegui copiar. Copie manualmente.");
      return;
    }
    setCopied(true);
    toast.success(`Chave Pix de ${ownerName} copiada.`);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="pix-box">
      <IconPix width={16} height={16} aria-hidden="true" />
      <span className="faint">{pixTypeLabel(pixKeyType)}</span>
      <span className="pix-key">{pixKey}</span>
      <button
        type="button"
        className="btn btn-sm btn-subtle"
        onClick={() => void handleCopy()}
        aria-label={`Copiar chave Pix de ${ownerName}`}
      >
        {copied ? <IconCheck width={16} height={16} /> : <IconCopy width={16} height={16} />}
        {copied ? "Copiado" : "Copiar"}
      </button>
    </div>
  );
}
